var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._m(0),(_vm.isLoading)?_c('loader-component'):_vm._e(),_c('cookie-component')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-main"},[_c('div',{staticClass:"container"})])
}]

export { render, staticRenderFns }